import { useEffect, useState } from 'react';
import { ChannelLink } from '../../../../components/Links/ChannelLink/ChannelLink';
import { isMaxPlatform } from '../../../../platform/platform';
import { getPlatform, PlatformType } from '../../../../utils/browser';
import detailStyles from '../ChallengeDetail.module.scss';
import image11 from './images/7-1-1.jpg';
import image12 from './images/7-1-2.jpg';
import image13 from './images/7-1-3.jpg';
import { ThinButton } from '../../../../components/Buttons/ThinButton/ThinButton';
import { useDispatch } from '../../../../hooks';
import { actionChallenge } from '../../../../redux/challenges/action-challenges.handler';
import { ErrorSnackbar } from '../../../../components/ErrorSnackbar/ErrorSnackbar';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';
import { getPlatformText } from '../../../../utils/platform-text';

export const SubscribeMainChannelDescription = () => {
    const [platform, setPlatform] = useState<PlatformType | null>(null);
    const dispatch = useDispatch();
    const [error, setError] = useState('');

    useEffect(() => {
        setPlatform(getPlatform());
    }, []);

    const getButtonName = () => {
        if (isMaxPlatform()) return 'Подписаться';
        switch (platform) {
            case PlatformType.iOS: return 'Подписаться';
            case PlatformType.Android:
            default: return 'Присоединиться';
        }
    }

    const getImage = () => {
        if (isMaxPlatform()) return image13;
        switch (platform) {
            case PlatformType.iOS: return image11;
            case PlatformType.Android:
            default: return image12;
        }
    }

    const onSubscribe = async () => {
        setError('');
        const resultAction = await dispatch(actionChallenge(0));        

        if (actionChallenge.fulfilled.match(resultAction)) {
            resultAction.payload.result
                ? window.history.back()
                : setError('Не подписан');
        }
    }

    return (
        <>
            <div className={detailStyles.description}>
                <p>
                    Откройте страницу <ChannelLink caption={getPlatformText('channelOfIn')} />
                </p>

                <p>
                    <div>
                        Нажмите <b>"{getButtonName()}"</b>
                    </div>
                    <ChallengeDetailHelpImage image={getImage()} helpText='Это картинка. Кнопка в самом канале.' />
                </p>
            </div>

            <ThinButton caption='Проверить подписку' handler={() => onSubscribe()} />
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
}